import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

function lineAnimation() {

  var data = [
    {el: "#lottie-camping", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Boarding_Camping.json"},
    {el: "#lottie-chemistry", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Academic_Chemistry.json"},
    {el: "#lottie-chemistry-girl", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Academic_Chemistry-Girl.json"},
    {el: "#lottie-chemistry-boy", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Academic_Chemistry-Boy.json"},
    {el: "#lottie-dog", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/MeetTheHead_Dog.json"},
    {el: "#lottie-geography", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Academic_Geography.json"},
    {el: "#lottie-geography-girl", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Academic_Geography-Girl.json"},
    {el: "#lottie-academic-student", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Academic_GoodStudent.json"},
    {el: "#lottie-dance", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Drama_Dance.json"},
    {el: "#lottie-guitarist", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Music_Guitarist.json"},
    {el: "#lottie-reading", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Pastoral_Reading.json"},
    {el: "#lottie-football", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Sport_Football.json"},
    {el: "#lottie-student-teacher", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/StudentAndTeacher.json"},
    {el: "#lottie-student-teacher-girl", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/StudentAndTeacher-Girl.json"},
    {el: "#lottie-sustainability", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Sustainability.json"},
    {el: "#lottie-meditation", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Wellbeing_Meditation.json"},
    {el: "#lottie-stretch", path: "https://www.cheamschool.co.uk/wp-content/themes/Cheam/assets/img/lottie/Wellbeing_Stretch.json"},
  ];

  
  data.forEach(function(curData) {
    var element = document.querySelector(curData.el),
    animation = lottie.loadAnimation({
      container: element,
      renderer: "svg",
      loop: true,
      autoplay: false,
      path: curData.path
    });
    
    animation.addEventListener("DOMLoaded", function() {
      ScrollTrigger.create({
        trigger: element,
        start: "top 75%",
        onToggle: function(self) {
          if (self.isActive) {
            if (curData.delay) {
              animation.goToAndStop(0);
              gsap.delayedCall(curData.delay, function() {
                animation.play();
              });
            } else {
              animation.play();
            }
          }
        }
      });
      ScrollTrigger.refresh();
    });
  
  });



}


export default lineAnimation;
